module.exports = __webpack_public_path__ + "img/triangle.369073d0.svg";